import DOMPurify from "dompurify";

import { sanitizeOptions } from "@/constants/sanitizeOptions";

export const getSanitizedData = (data: string) => {
  if (typeof window === "undefined") {
    return data;
  }
  return DOMPurify.sanitize(data || "", {
    ALLOWED_TAGS: sanitizeOptions.ALLOWED_TAGS,
    ALLOWED_ATTR: sanitizeOptions.ALLOWED_ATTR,
    FORBID_TAGS: ["script", "iframe", "object", "embed"],
  });
};
